import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { EDITOR_ACCENT } from "../editorUiConstants";

const PropertySection = ({ title, description, children, sx }) => (
  <Box
    sx={{
      mb: 2.5,
      pb: 2.5,
      borderBottom: "1px solid #eef2f7",
      "&:last-of-type": { borderBottom: "none", pb: 0 },
      ...sx,
    }}
  >
    <Typography
      variant="overline"
      sx={{
        display: "block",
        color: EDITOR_ACCENT,
        fontWeight: 700,
        letterSpacing: "0.08em",
        lineHeight: 1.4,
        mb: description ? 0.5 : 1.25,
      }}
    >
      {title}
    </Typography>
    {description ? (
      <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1.5, lineHeight: 1.5 }}>
        {description}
      </Typography>
    ) : null}
    {children}
  </Box>
);

PropertySection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  children: PropTypes.node,
  sx: PropTypes.object,
};

export default PropertySection;
 